/**
 * Jurisdiction badges под h1 на legal-страницах.
 * Показывает под каким законодательством документ написан.
 * Юзер видит «это про меня?» с первого экрана.
 */
interface Props {
  jurisdictions?: Array<'ru' | 'eu' | 'us'>;
}

// flag-icons class codes: ISO 3166-1 alpha-2 lower-case (`ru`, `us`)
// + special non-country code `eu` для Евросоюза.
const LABELS: Record<'ru' | 'eu' | 'us', { law: string; region: string; flagCode: string }> = {
  ru: { law: '152-ФЗ', region: 'Россия', flagCode: 'ru' },
  eu: { law: 'GDPR', region: 'ЕС/EEA', flagCode: 'eu' },
  us: { law: 'CCPA/CPRA', region: 'Калифорния, США', flagCode: 'us' },
};

export function JurisdictionBadges({ jurisdictions = ['ru', 'eu', 'us'] }: Props) {
  return (
    <div className="mt-3 flex flex-wrap gap-2" aria-label="Юрисдикции документа">
      {jurisdictions.map((j) => {
        const { law, region, flagCode } = LABELS[j];
        return (
          <span
            key={j}
            className="inline-flex items-center gap-1.5 rounded-md border border-border bg-surface-subtle px-2 py-1 text-xs text-text-secondary"
            title={`Документ соответствует ${law} (${region})`}
          >
            {/* flag-icons рендерит SVG-флаг как ::before background.
                Без `fis` — дефолтный прямоугольник 4:3. */}
            <span className={`fi fi-${flagCode} rounded-sm`} aria-hidden style={{ width: '1.25em', height: '0.94em' }} />
            <span>·</span>
            <span className="font-medium text-text-primary">{law}</span>
            <span>·</span>
            <span>{region}</span>
          </span>
        );
      })}
    </div>
  );
}
